import './Input.css';
import Form from 'react-bootstrap/Form';

function TextAreaInput(props) {
  const classes = 'position-relative ' + props.formGroupClasses;
  return (
    <Form.Group controlId={props.name} className={classes} >
      <Form.Label className={props.formLabelClasses} >{props.label}</Form.Label>
      <Form.Control 
        as="textarea" 
        rows={3}
        name={props.name}  
        className={props.inputClasses} 
        placeholder={props.placeholder} 
        value={props.value} 
        onInput={props.onInput}
        onKeyDown={props.onKeyDown}
        onChange={props.onChange} 
        onClick={props.onClick} 
        pattern={props.pattern} 
        autoComplete="off"
        required/>
      <Form.Control.Feedback type="invalid">
        This field is required.
      </Form.Control.Feedback>
      <Form.Text>
        {props.descripttion} 
      </Form.Text>
    </Form.Group>
  );
}

export default TextAreaInput;
